import factoryWireframe from "../assets/factory-wireframe.png";
import styles from "./FactoryIllustration.module.css";

/**
 * 하단 장식용 공장 와이어프레임 이미지 (교체 가능한 리소스)
 */
export function FactoryIllustration({ className }: { className?: string }) {
  return (
    <img
      className={[styles.factory, className].filter(Boolean).join(" ")}
      src={factoryWireframe}
      alt=""
      aria-hidden
      draggable={false}
    />
  );
}
